// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_h6-6";
export var emphasizeQuantity = "_h6-3";
export var flatBottomCorners = "_h6-5";
export var productImage = "_h6-0";
export var quantityContainer = "_h6-2";
export var tooltip = "_h6-1";
export var wrapAndEllipsesOverflow = "_h6-4";